/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {useIntl} from "react-intl";
import {AELink} from "../../../_emywork/components/AELink";
import {AESVG} from "../../../_emywork/components/svg";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../Dashboard/_redux/actions";
import {CONTEXT} from "../../modules/EmyServices/helpers/ModuleHelpers";

const Block = ({title, value, to =`/${CONTEXT}`}) =>{
  const {formatMessage} = useIntl()
  return (
    <div>
      <div className="text-dark font-weight-bolder font-size-h2 mt-3">
        {value}
      </div>
      <AELink
        to={to}
        className={"text-muted text-hover-primary font-weight-bold font-size-lg mt-1"}
      >
        {formatMessage({id: title})}
      </AELink>
    </div>
  )
}

export function EmyServicesWidget({}) {
  const dispatch = useDispatch()
  const emyServices = useSelector(({statistics})=>statistics.emyServices)

  useEffect(()=>{
    dispatch(actions.fetchEmyServicesStatistics())
  }, [])

  return (
    <>
      <div
        className={`card card-custom bgi-no-repeat card-stretch gutter-b`}
        style={{
          // height: '150px',
          backgroundPosition: 'right top',
          backgroundSize: '40% auto',
          backgroundImage: `url('${toAbsoluteUrl('/media/svg/shapes/abstract-2.svg')}')`,
        }}
      >
        <div className="card-body d-flex align-items-end justify-content-between">
          <div>
            <AESVG
              size={'3x'}
              variant={`primary`}
              className={'ml-n2'}
              path={'/Design/PenAndRuller.svg'}
            />
            <Block title={'WIDGET.EMY_SERVICE.TITLE'} value={emyServices.total}/>
            <Block title={'WIDGET.EMY_SERVICE.MY.TITLE'} value={emyServices.my_total}/>
          </div>

        </div>
      </div>
    </>
  );
}
